import ProductCard from '@layouts/ProductList/ProductList1/ProductCard';

export default ProductCard;
